import { useState } from "react";
import { Send, CheckCircle2 } from "lucide-react";
import { Seo } from "../components/Seo";
import { sendContact, errorMessage } from "../lib/api";

export default function ContactPage() {
    const [form, setForm] = useState({ name: "", email: "", message: "" });
    const [status, setStatus] = useState("idle"); // idle | sending | sent | error
    const [error, setError] = useState(null);

    const submit = async (e) => {
        e.preventDefault();
        setStatus("sending");
        setError(null);
        try {
            await sendContact(form);
            setStatus("sent");
        } catch (err) {
            setStatus("error");
            setError(errorMessage(err));
        }
    };

    const field = "w-full border-2 border-black bg-white px-4 py-3 text-sm font-medium outline-none focus:border-[#0284C7]";

    return (
        <main className="py-14 px-6 max-w-3xl mx-auto min-h-[60vh]">
            <Seo
                title="Contato e suporte — ScorpionPDF"
                description="Fale com a equipe do ScorpionPDF: dúvidas, problemas com uma operação ou sugestões de novas ferramentas."
            />
            <span className="font-mono-tag text-xs font-bold text-[#0284C7] uppercase">Suporte</span>
            <h1 className="font-poster text-5xl md:text-6xl text-black mt-1">Contato</h1>
            <p className="text-gray-700 mt-4">
                Problema com uma operação, dúvida sobre privacidade ou ideia de ferramenta nova? Escreva aqui.
            </p>

            {status === "sent" ? (
                <div className="mt-8 border-2 border-black bg-[#F0F9FF] p-8 text-center hard-shadow" data-testid="contact-success">
                    <CheckCircle2 className="w-10 h-10 text-[#0284C7] mx-auto mb-3" aria-hidden="true" />
                    <p className="font-poster text-2xl text-black">MENSAGEM ENVIADA</p>
                    <p className="text-sm text-gray-700 mt-2">Recebemos seu contato e responderemos no e-mail informado.</p>
                </div>
            ) : (
                <form onSubmit={submit} className="mt-8 border-2 border-black bg-white p-6 hard-shadow space-y-4" data-testid="contact-form">
                    <div>
                        <label htmlFor="contact-name" className="block font-mono-tag text-xs font-bold uppercase tracking-wider text-black mb-2">Nome</label>
                        <input id="contact-name" required maxLength={120} className={field} data-testid="contact-name"
                            value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
                    </div>
                    <div>
                        <label htmlFor="contact-email" className="block font-mono-tag text-xs font-bold uppercase tracking-wider text-black mb-2">E-mail</label>
                        <input id="contact-email" type="email" required maxLength={200} className={field} data-testid="contact-email"
                            value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
                    </div>
                    <div>
                        <label htmlFor="contact-message" className="block font-mono-tag text-xs font-bold uppercase tracking-wider text-black mb-2">Mensagem</label>
                        <textarea id="contact-message" required rows={5} maxLength={4000} className={field} data-testid="contact-message"
                            value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} />
                    </div>
                    {status === "error" && (
                        <p className="text-sm text-red-800 font-medium" role="alert" data-testid="contact-error">{error}</p>
                    )}
                    <button
                        type="submit"
                        disabled={status === "sending"}
                        data-testid="contact-submit"
                        className="w-full py-4 bg-[#0284C7] hover:bg-black disabled:bg-gray-300 text-white font-poster text-xl tracking-wide transition-colors inline-flex items-center justify-center gap-2"
                    >
                        <Send className="w-5 h-5" aria-hidden="true" />
                        {status === "sending" ? "ENVIANDO…" : "ENVIAR MENSAGEM"}
                    </button>
                </form>
            )}
        </main>
    );
}
